/** Extract display fields from a WhatsApp template payload. */
export function getTemplatePreview(template) {
  if (!template) return null;
  const components = Array.isArray(template.components) ? template.components : [];
  const byType = (type) =>
    components.find((row) => String(row.type || "").toUpperCase() === type);
  const header = byType("HEADER");
  const body = byType("BODY");
  const footer = byType("FOOTER");
  const buttons = byType("BUTTONS");
  const headerFormat = String(header?.format || "TEXT").toUpperCase();
  return {
    name: template.name || template.template_name || "",
    language: template.language || "",
    category: template.category || "",
    status: template.template_status || template.status || "",
    headerText: header?.text || "",
    headerFormat,
    body: body?.text || template.body || template.template_body || "",
    footer: footer?.text || "",
    buttons: (buttons?.buttons || [])
      .map((btn) => btn.text || btn.example || "")
      .filter(Boolean),
  };
}

export function isApprovedTemplate(tpl) {
  const status = String(tpl?.template_status || tpl?.status || "")
    .trim()
    .toUpperCase();
  return status === "APPROVED";
}

export function templateKey(tpl) {
  return String(
    tpl?._id ||
      tpl?.template_id ||
      `${tpl?.name || ""}|${tpl?.language || ""}|${tpl?.category || ""}`,
  );
}

export function filterApprovedTemplates(list = []) {
  return (Array.isArray(list) ? list : []).filter(isApprovedTemplate);
}
